import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

import { clsx } from 'clsx'

import styles from './ContentItemCard.module.css'

export const ContentItemCardView = forwardRef<
  HTMLElement,
  Omit<ComponentPropsWithoutRef<'article'>, 'children' | 'content'> & {
    actions: ReactNode
    content: ReactNode
    media?: ReactNode
    meta?: ReactNode
    /** The Notes trigger, pinned to the card's top-right corner. */
    notes?: ReactNode
  }
>(({ actions, className, content, media, meta, notes, ...props }, ref) => (
  <article ref={ref} className={clsx(styles.card, className)} {...props}>
    {notes && <div className={styles.notes}>{notes}</div>}
    <div className={styles.inner}>
      <div className={styles.body}>
        <div className={styles.content}>
          {content}
          {media}
        </div>
      </div>
      <footer className={styles.footer}>
        {meta}
        <div className={styles.footerActions}>{actions}</div>
      </footer>
    </div>
  </article>
))

ContentItemCardView.displayName = 'ContentItemCardView'
